<template>
    <div class="betslip-selection__list responsive__element">
        <transition-group
            name="animation-list__slide-in-left-"
            tag="div"
            class="betslip-selection__list-wrapper"
        >
            <div
                v-for="selection in selections"
                :key="selection.getOddUuid()"
                class="betslip-selection__item"
            >
                <Selection
                    :selection="selection"
                    :error="selectionErrors[selection.getEventId()]"
                    :broadcasts="broadcasts"
                    :oddValueDynamics="oddValueDynamics"
                    @removeClick="onRemoveClick"
                />
            </div>
        </transition-group>
    </div>
</template>

<script>
    import Selection from './Selection.vue';

    export default {
        name: 'SimpleBetSlip',
        props: {
            selections: {
                type: Array,
                required: true
            },
            selectionErrors: {
                type: Object,
                required: false,
                default() {
                    return {};
                }
            },
            broadcasts: {
                type: Object,
                required: false,
                default: () => ({}),
            },
            oddValueDynamics: {
                type: Object,
                required: false,
            },
        },
        methods: {
            onRemoveClick(selection) {
                this.$emit('removeClick', selection);
            }
        },
        components: {
            Selection,
        },
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/shared/betSlip/SimpleBetSlip.vue